export default "__VITE_ASSET__BsOP1KWd__"